module.exports = __webpack_public_path__ + "static/media/slide-2.967fa514.svg";